<template>
  <div class="row-supplier">
    <div class="main-width set-position">
      <!-- <h4>合作供应商</h4> -->
    <!--   <hr id="supplier-hr1"/>
      <hr id="supplier-hr2"/> -->
      <div id="supplier">
      <!--   <table>
          <tbody>
          <div id="supplier-carousel-generic" class="carousel slide" data-interval="3000" data-ride="carousel">
            <ol class="carousel-indicators hidden">
              <li data-target="#supplier-carousel-generic" data-slide-to="0" class="active"></li>
              <li data-target="#supplier-carousel-generic" data-slide-to="1"></li>
            </ol>
            <div class="carousel-inner" role="listbox" id="supplier-roll">
              <div class="item active">
                <tr>
                  <td class="partners-img">
                    <img src="static/imgs/zhongmei.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/zhenengdianli.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img id="img-width" src="static/imgs/SKF.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/coalgroup.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/baogang.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/tongling.png" alt=""/>
                  </td>
                </tr>
              </div>
              <div class="item">
                <tr>
                  <td class="partners-img">
                    <img src="static/imgs/wanfangdian.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/xinyu.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img class="img-width" src="static/imgs/FAG.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/shenhua.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/juhua.png" alt=""/>
                  </td>
                  <td class="partners-img">
                    <img src="static/imgs/jiangxitongye.png" alt=""/>
                  </td>
                </tr>
              </div>
            </div>
          </div>
          </tbody>
        </table> -->
      </div>
    </div>
  </div>
</template>
<style>
  /*row-supplier*/
  .row-supplier > .main-width {
    clear: both;
    height: 101px;
  }

  .row-supplier hr {
    position: absolute;
    /*top: 25px;*/
    margin: 0;
    padding: 0
  }

  #supplier {
    margin-top: 29px;
    text-align: center;
  }

  #supplier > table {
    margin: 0 auto;
    border-spacing: 30px 10px !important;
    border-collapse: separate !important;
  }

  .partners-img {
    text-align: center;
    width: 160px;
    height: 54px;
    border: 1px solid #D5D5D5;
  }

  .partners-img > img {
    width: 100%;
    max-height: 71px;
  }

  #img-width {
    /*height: 54px;*/
  }

  #supplier-hr1 {
    height: 2px;
    width: 95px;
    background-color: @primary;
    top: 27px;
    z-index: 99;
  }

  #supplier-hr2 {
    height: 1px;
    width: 100%;
  }

  #supplier-roll .active {
    border: none !important;
  }

  #supplier-carousel-generic {
    cursor: pointer;
  }
</style>
<script>
  export default {
    name: 'gsupplier',
    mounted: function () {
      this.imgsRoll()
    },
    methods: {
      imgsRoll: function () {

      }
    }
  }
</script>




// WEBPACK FOOTER //
// G-supplier.vue?4137f1ae